// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.main-signup-container{
 
    width: 100%;
  height: 100vh;
  
   display: flex;
   flex-direction: column;
  justify-content: center;
  align-items: center;
 
}
.SignUp-main-container{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 134px);
}

.SignUp_main_container{
  min-height: 100vh;
}
.inputDivStyle-signup {
  width: 368px;
  
}
.swal2-title {
  color: #061522;
  text-align: center;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 111.111% */
  }
  
.btn__back{
  background-color: #fff;
  color: #405261;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 128.571% */
}
.btn__back_disabled{
  background-color: #fff;
  color: #405261;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 128.571% */
cursor: not-allowed;
}
.slider-signup{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 90px;
}

.admin_password_input {
  margin-bottom: 0 !important;
  height: auto !important;
}
.textDiv {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 25px;
}
.text__create {
  color: #061522;

  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px; /* 121.429% */
  margin-bottom: 6px;
}
.text__start {
  color: #556575;

  font-size: 14px;
  font-style: normal;
  font-weight: extralight;
  line-height: 18px;
}
.text__create_Illustration{
  color: #061522;

  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px; /* 121.429% */
  margin-bottom: 6px;
  text-align: center;
}
.text__start_Illustration{
  color: #556575;

  font-size: 14px;
  font-style: normal;
  font-weight: extralight;
  line-height: 18px;
  text-align: center;
}

.btn-class {
  margin-top: 33px;
}
.forgetStyle {
  font-family: Mulish;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 13px;
  display: flex;
  align-items: center;
  color: #5f44f7;
  text-decoration: none;
  margin-top: 10px;
}

.stepper__123 {
  display: flex;
  gap: 5px;
}
.step__123 {
  color: #061522;
text-align: center; 
    margin-right: 189px;
    
  font-size: 12px;

  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
  text-transform: uppercase;
  margin-bottom: 7px;
}
.step__left {
  color: #061522;
text-align: center; 

    margin-left: 184px;
    margin-right: 5px;

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
  text-transform: uppercase;
  margin-bottom: 7px;
}
.input__error{
  border-color: #FF4D4F;
}


.input__success{
}
.input__error:focus {
  border-color: #FF4D4F; 
  box-shadow: 0 0 1px #FF4D4F; 
}
.input__success:focus{
  border-color: #96ad8b;
    box-shadow: 0 0 1px #52C41A; 

}
.underline__1 {
  border-radius: 2.5px;
  background: #e5e9ec;
  width: 179px;
  height: 4px;
  flex-shrink: 0;
}

.underline__1.underline__1_active {
  background: #148dfd;
}
.underline__1_active {
  background-color: #148dfd;
}

.underline__1_completed {
  background-color: #52C41A;
}
.underline__2 {
  border-radius: 2.5px;
  background: #e5e9ec;
  width: 77px;
  height: 4px;
  flex-shrink: 0;
}
.underline__3 {
  border-radius: 2.5px;
  background: #e5e9ec;
  width: 77px;
  height: 4px;
  flex-shrink: 0;
}

.privacy__01 {
  display: flex;
  gap: 30px;
  color: #556575;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.a__singIn {
  margin-top: 10px;
  color: #405261;
  text-align: center;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 112.5% */
}
.check__box {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}
.b__signIn {
  color: #148dfd;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-decoration: none;
  cursor: pointer;
}
.Enter__text{
  color: #405261;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-top: 34px;
}
.Registration-Illustration{
  display: flex;
  justify-content: center;
  margin-bottom: 41px;
}
/* -------------------------------------x----------------media Query------------------------------------------ */

@media screen and (max-width: 550px) {

  .textDiv {
    color: #5f44f7;
    margin: 0px 0px 0px 0px;
    font-size: 22px;
    margin-bottom: 25px;
  }
  .inputDivStyle-signup {

    width: 100%;
    padding: 24px;
  }
  .footer__trust {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #777777;
    border: none;
    outline: none;
    padding: 10px 5px;
  }
}

@media screen and (max-width: 375px) {
  .footer__trust {
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/SignUp/style.css"],"names":[],"mappings":";AACA;;IAEI,WAAW;EACb,aAAa;;GAEZ,aAAa;GACb,sBAAsB;EACvB,uBAAuB;EACvB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;;AAEd;AACA;EACE,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC;;AAEF;EACE,sBAAsB;EACtB,cAAc;AAChB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC,mBAAmB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;AACpB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,cAAc;AAChB,kBAAkB;IACd,mBAAmB;;EAErB,eAAe;;EAEf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB,kBAAkB;;IAEd,kBAAkB;IAClB,iBAAiB;;EAEnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;;AAGA;AACA;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;IACnB,2BAA2B;;AAE/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,cAAc;AAChB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,gBAAgB;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,gHAAgH;;AAEhH;;EAEE;IACE,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["\n.main-signup-container{\n \n    width: 100%;\n  height: 100vh;\n  \n   display: flex;\n   flex-direction: column;\n  justify-content: center;\n  align-items: center;\n \n}\n.SignUp-main-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fff;\n  min-height: calc(100vh - 134px);\n}\n\n.SignUp_main_container{\n  min-height: 100vh;\n}\n.inputDivStyle-signup {\n  width: 368px;\n  \n}\n.swal2-title {\n  color: #061522;\n  text-align: center;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 111.111% */\n  }\n  \n.btn__back{\n  background-color: #fff;\n  color: #405261;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 18px; /* 128.571% */\n}\n.btn__back_disabled{\n  background-color: #fff;\n  color: #405261;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 18px; /* 128.571% */\ncursor: not-allowed;\n}\n.slider-signup{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 90px;\n}\n\n.admin_password_input {\n  margin-bottom: 0 !important;\n  height: auto !important;\n}\n.textDiv {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-bottom: 25px;\n}\n.text__create {\n  color: #061522;\n\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 34px; /* 121.429% */\n  margin-bottom: 6px;\n}\n.text__start {\n  color: #556575;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: extralight;\n  line-height: 18px;\n}\n.text__create_Illustration{\n  color: #061522;\n\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 34px; /* 121.429% */\n  margin-bottom: 6px;\n  text-align: center;\n}\n.text__start_Illustration{\n  color: #556575;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: extralight;\n  line-height: 18px;\n  text-align: center;\n}\n\n.btn-class {\n  margin-top: 33px;\n}\n.forgetStyle {\n  font-family: Mulish;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 13px;\n  display: flex;\n  align-items: center;\n  color: #5f44f7;\n  text-decoration: none;\n  margin-top: 10px;\n}\n\n.stepper__123 {\n  display: flex;\n  gap: 5px;\n}\n.step__123 {\n  color: #061522;\ntext-align: center; \n    margin-right: 189px;\n    \n  font-size: 12px;\n\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px; /* 150% */\n  text-transform: uppercase;\n  margin-bottom: 7px;\n}\n.step__left {\n  color: #061522;\ntext-align: center; \n\n    margin-left: 184px;\n    margin-right: 5px;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px; /* 150% */\n  text-transform: uppercase;\n  margin-bottom: 7px;\n}\n.input__error{\n  border-color: #FF4D4F;\n}\n\n\n.input__success{\n}\n.input__error:focus {\n  border-color: #FF4D4F; \n  box-shadow: 0 0 1px #FF4D4F; \n}\n.input__success:focus{\n  border-color: #96ad8b;\n    box-shadow: 0 0 1px #52C41A; \n\n}\n.underline__1 {\n  border-radius: 2.5px;\n  background: #e5e9ec;\n  width: 179px;\n  height: 4px;\n  flex-shrink: 0;\n}\n\n.underline__1.underline__1_active {\n  background: #148dfd;\n}\n.underline__1_active {\n  background-color: #148dfd;\n}\n\n.underline__1_completed {\n  background-color: #52C41A;\n}\n.underline__2 {\n  border-radius: 2.5px;\n  background: #e5e9ec;\n  width: 77px;\n  height: 4px;\n  flex-shrink: 0;\n}\n.underline__3 {\n  border-radius: 2.5px;\n  background: #e5e9ec;\n  width: 77px;\n  height: 4px;\n  flex-shrink: 0;\n}\n\n.privacy__01 {\n  display: flex;\n  gap: 30px;\n  color: #556575;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.a__singIn {\n  margin-top: 10px;\n  color: #405261;\n  text-align: center;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 112.5% */\n}\n.check__box {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 14px;\n}\n.b__signIn {\n  color: #148dfd;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  text-decoration: none;\n  cursor: pointer;\n}\n.Enter__text{\n  color: #405261;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\nmargin-top: 34px;\n}\n.Registration-Illustration{\n  display: flex;\n  justify-content: center;\n  margin-bottom: 41px;\n}\n/* -------------------------------------x----------------media Query------------------------------------------ */\n\n@media screen and (max-width: 550px) {\n\n  .textDiv {\n    color: #5f44f7;\n    margin: 0px 0px 0px 0px;\n    font-size: 22px;\n    margin-bottom: 25px;\n  }\n  .inputDivStyle-signup {\n\n    width: 100%;\n    padding: 24px;\n  }\n  .footer__trust {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #777777;\n    border: none;\n    outline: none;\n    padding: 10px 5px;\n  }\n}\n\n@media screen and (max-width: 375px) {\n  .footer__trust {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 10px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
